<template>
  <div id="sponsor">
    <h2 class="sponsor-type">Partners</h2>
    <hr>
    <sponsor-component
        name="SIGCHI"
        img="sigchi"
        type="Partner"
        level=""
        websiteLink="https://sigchi.org"
        optionClass="invert"
    />
    <sponsor-component
        name="ACM"
        img="acm"
        type="Partner"
        level=""
        websiteLink="https://acm.org"
        optionClass="invert"
    />
    <sponsor-component
        name="Ville de Bordeaux"
        img="ville-de-bordeaux"
        type="Partner"
        level=""
        websiteLink="https://www.bordeaux.fr/"
    />

    <sponsor-component
      name="Bordeaux Tourism & Congrès"
      img="bordeaux-tourism"
      type="Partner"
      level=""
      websiteLink="https://www.bordeaux-tourisme.com/"
    />
    <h2 class="sponsor-type next">Institutional</h2>
    <hr>
    <sponsor-component
        name="AFIHM"
        img="afihm"
        type="Sponsor"
        level="Silver"
        websiteLink="https://www.afihm.org/"
    />
    <sponsor-component
        name="Bordeaux INP"
        img="bordeaux-inp"
        type="Institutional"
        level=""
        optionClass="smaller"
        websiteLink="https://www.bordeaux-inp.fr/fr"
    />
    <sponsor-component
      name="ENSAD"
      img="EAD"
      type="Institutional"
      level=""
      optionClass="higher"
      websiteLink="https://www.ensad.fr/fr/universite-psl"
    />
    <sponsor-component
      name="Inria"
      img="inria"
      type="Institutional"
      level=""
      optionClass="higher"
      websiteLink="https://inria.fr/"
    />
    <sponsor-component
      name="LaBRI"
      img="LaBRI"
      type="Institutional"
      level=""
      optionClass="smaller"
      websiteLink="https://www.labri.fr/"
    />
    <sponsor-component
      name="Université Bordeaux"
      img="universite_bordeaux"
      type="Institutional"
      level=""
      optionClass=""
      websiteLink="https://www.u-bordeaux.fr"
    />
    <sponsor-component
        name="CNRS"
        img="cnrs"
        type="Institutional"
        level=""
        optionClass=""
        websiteLink="https://www.cnrs.fr"
    />
    <h2 class="sponsor-type next">Sponsors</h2>
    <hr>
    <h3 class="sponsor-level" >Silver</h3>
    <sponsor-component
        name="Force Dimension"
        img="force-dimension-1"
        type="Sponsor"
        level="Silver"
        websiteLink="https://www.forcedimension.com/"
    />
    <sponsor-component
      name="Immersion"
      img="immersion"
      type="Sponsor"
      optionClass="larger"
      level="Silver"
      websiteLink="https://www.immersion.fr/"
    />
    <sponsor-component
        name="PEPR Ensemble"
        img="logo-pepr"
        type="Sponsor"
        level="Silver"
        websiteLink="https://pepr-ensemble.fr/"
    />
    <h3  class="sponsor-level" style="padding-top: 10px">Bronze</h3>
    <sponsor-component
        name="Vibra Nova"
        img="vibra-nova"
        type="Sponsor"
        level="Bronze"
        websiteLink="https://www.vibra-nova.com/"
    />
<!--    <hr>-->
  </div>
</template>


<script>

import SponsorComponent from '@/components/SponsorComponent.vue'

export default {
  name: 'SponsorDivComponent',
  components: { SponsorComponent }
}
</script>

<style scoped>


img.sponsor {
  max-width: 80%;
  padding-bottom: 1rem;
}

#sponsor {
  text-align: center;
  border-radius: inherit;
  border-radius: 15px;
  background: var(--foreground);
  padding: 20px;
}

.sponsor-type.next{
  padding-top: 1.5em;
}

.sponsor-level{
padding-bottom: 0.5rem;
font-style:italic;
}

</style>
